import { ReactElement, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  colorBgWithStateAutoFont,
  colorBorder,
  colorFillColor
} from 'mt-react-theme-manager';

import Modal from '..';
import { Preset } from '../../components/Button';
import { TextButton } from '../../components/TextButton';
import ContentAreaFrame from '../../components/ContentAreaFrame';
import EmailInput from '../../components/EmailInput';

import './style.scss';

interface ChangeFastOnboardEmailModalProps {
  onComplete: (email?: string) => void;
}

export default function ChangeFastOnboardEmailModal({
  onComplete
}: ChangeFastOnboardEmailModalProps): ReactElement {
  const { t } = useTranslation();
  const [{ email, isEmailValid }, setEmailInfo] = useState({
    email: '',
    isEmailValid: false
  });

  const emailInputId = 'change-fast-onboard-email-input';

  const onChangeEmail = useCallback(
    (newEmail: string, newEmailIsValid: boolean) => {
      setEmailInfo({
        email: newEmail,
        isEmailValid: newEmailIsValid
      });
    },
    []
  );

  const changeEmail = useCallback(() => onComplete(email), [onComplete, email]);
  const cancelButton = useCallback(() => onComplete(), [onComplete]);

  return (
    <Modal>
      <form onSubmit={changeEmail}>
        <ContentAreaFrame className="change-fast-onboard-email-modal">
          <div className="title">
            {t('ChangeFastOnboardEmailModal.heading')}
          </div>
          <label className="description" htmlFor={emailInputId}>
            {t('ChangeFastOnboardEmailModal.description')}
          </label>
          <EmailInput
            className={`email-input ${colorBorder('primary', 'base')} ${colorFillColor(`primary`, 'base')}`}
            onChangeText={onChangeEmail}
            value={email}
            id={emailInputId}
          />
          <div className="button-container">
            <TextButton
              big
              preset={Preset.None}
              className={colorBgWithStateAutoFont('secondary')}
              text={t('ChangeFastOnboardEmailModal.cancel')}
              onPress={cancelButton}
            />
            <TextButton
              big
              preset={Preset.None}
              className={colorBgWithStateAutoFont('primary')}
              text={t('ChangeFastOnboardEmailModal.change')}
              type="submit"
              disabled={!isEmailValid}
            />
          </div>
        </ContentAreaFrame>
      </form>
    </Modal>
  );
}
